import axios from "axios";
import React, { useEffect, useState } from "react";
import Masonry from "react-masonry-css";

const Gallary = () => {
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    axios.get(`https://admin.tulikaarts.in/api/gallery`)
      .then((response) => {
        setGalleryImages(response.data?.data || []);
      })
      .catch((error) => console.log(error));
  }, []);

  // Breakpoints for responsive layout
  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1,
  };

  return (
    <section className="gallery py-5">
      <div className="container">
        <h2 className="text-center mt-9">Art Gallery</h2>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {galleryImages.map((image, index) => (
            <div key={index} className="painting mb-4">
              <img
                src={`https://admin.tulikaarts.in/${image?.gallery_image}`}
                alt={`Gallery Image ${index + 1}`}
                style={{ width: "100%", borderRadius: "8px" }}
              />
            </div>
          ))}
        </Masonry>
      </div>
    </section>
  );
};

export default Gallary;
